<div class="heading">
    <p *ngIf="data?.isApprove">Approve Prompt</p>
    <p *ngIf="!data?.isApprove">Reject Prompt</p>
</div>
<form #commentForm="ngForm" (ngSubmit)="rejectPrompt(commentForm)">
    <div class="instruction">
        <div *ngIf="data?.isApprove">
            <p class="mb-32">Approving this prompt will result in its publication and availability to end users for their consumption.</p>
            <p class="mb-32">Are you sure, you want to proceed with publishing it?</p>
        </div>

        <div *ngIf="!data?.isApprove">
            <label style="font-size: 14px; color: #5E5E72; margin-bottom: 4px; display: inline-block; font-weight: 700;">Reason for Rejection<span style="color: red;">*</span></label>
            <textarea placeholder="Enter comments here" style="width: 320px; height: 109px; font-family: 'Lato', sans-serif; border: 2px solid #E1E1EA; border-radius: 4px; padding: 10px; font-size: 16px;" [(ngModel)]="rejectionReason" required #commentsField="ngModel" [ngModelOptions]="{standalone: true}"></textarea>
            <div *ngIf="formSubmitted && commentsField.invalid" style="color: red;">
                Comments are required.
            </div>
        </div>


    </div>
    <div class="btn-container">
        <app-button [type]="'secondary'" [buttonType]="'button'" [buttonText]="'Cancel'" class="w-50 mr-12"
            (click)="cancelPrompt()"></app-button>
        <app-button [type]="'primary'" [buttonType]="'button'" [buttonText]="'Reject'" class="w-50" (click)="rejectPrompt(commentForm)" *ngIf="!data?.isApprove"></app-button>
        <app-button [type]="'primary'" [buttonType]="'button'" [buttonText]="'Publish'" class="w-50"
            (click)="approvePrompt()" *ngIf="data?.isApprove"></app-button>
    </div>
</form>